import React from "react";
//#region types
import { FormEnums } from "models/enums";
import { FormFieldProps } from "models/propTypes/genericFormProps";
//#endregion
//#region components
import * as FormFields from "../forms/formFields";
//#endregion

function FormField<T extends Record<string, any>>(props: FormFieldProps<T>) {
  const FieldComponent = React.useMemo(() => {
    switch (props.field.type) {
      case FormEnums.FormFieldType.EMAIL:
      case FormEnums.FormFieldType.TEXT:
      case FormEnums.FormFieldType.PASSWORD:
      case FormEnums.FormFieldType.CURRENCY:
      case FormEnums.FormFieldType.NUMBER:
        return FormFields.InputFormField;
      case FormEnums.FormFieldType.TEXTAREA:
        return FormFields.TextAreaFormField;
      case FormEnums.FormFieldType.AUTOCOMPLETE:
        return FormFields.AutoCompleteTextFormField;
      case FormEnums.FormFieldType.TOGGLE:
        return FormFields.ToggleFormField;
      case FormEnums.FormFieldType.CHECKBOX:
        return FormFields.CheckBoxFormField;
      case FormEnums.FormFieldType.DATE:
        return FormFields.DatePickerFormField;
      case FormEnums.FormFieldType.DATERANGE:
        return FormFields.DateRangePickerFormField;
      case FormEnums.FormFieldType.TIME:
        return FormFields.TimePickerFormField;
      case FormEnums.FormFieldType.MONTHRANGE:
        return FormFields.MonthRangePickerFormField;
      case FormEnums.FormFieldType.MONTH:
        return FormFields.MonthPickerFormField;
      case FormEnums.FormFieldType.SUGGESTIONS:
        return FormFields.InputSuggestionsFormField;
      case FormEnums.FormFieldType.FILEUPLOADER:
        return FormFields.FileUploaderFormField;
      case FormEnums.FormFieldType.SELECTION:
        return FormFields.SelectionFormField;
      case FormEnums.FormFieldType.BOOLEANSELECTION:
        return FormFields.BooleanSelectionFormField;
      case FormEnums.FormFieldType.TABLELIST:
        return FormFields.TableListFormField;
      case FormEnums.FormFieldType.CUSTOM:
        return FormFields.CustomFormField;
      case FormEnums.FormFieldType.SELECTIONTILE:
        return FormFields.SelectionTileFormField;
      case FormEnums.FormFieldType.SEARCHRESULTS:
        return FormFields.SearchResultsFormField;
      case FormEnums.FormFieldType.CHOICE:
        return FormFields.ChoiceChipsFormField;
      case FormEnums.FormFieldType.MULTIPLESELECTION:
        return FormFields.MultiSelectionChipsFormField;
      case FormEnums.FormFieldType.TABLELISTSELECTION:
        return FormFields.TableListSelectionFormField;
      case FormEnums.FormFieldType.EDITABLETABLE:
        return FormFields.EditableTableFormField;
      case FormEnums.FormFieldType.DIMENSIONSELECTOR:
        return FormFields.DimensionSelectorFormField;
      case FormEnums.FormFieldType.DIMENSIONINPUTSELECTOR:
        return FormFields.DimensionInputSelectorFormField;
      case FormEnums.FormFieldType.DIMENSIONMULTIPLEINPUTSELECTOR:
        return FormFields.DimensionMultipleInputSelectorFormField;
      case FormEnums.FormFieldType.MULTIPLEINPUT:
        return FormFields.MultipleInputFormField;
      case FormEnums.FormFieldType.RADIOSELECTIONGROUP:
        return FormFields.RadioSelectionFormField;
      case FormEnums.FormFieldType.CHECKBOXSELECTIONGROUP:
        return FormFields.CheckboxSelectionFormField;
      case FormEnums.FormFieldType.CURRENCYRANGE:
      case FormEnums.FormFieldType.NUMBERRANGE:
        return FormFields.NumberRangeFormField;
      case FormEnums.FormFieldType.DEFAULTTAG:
        return FormFields.DefaultTagFormField;
      case FormEnums.FormFieldType.SELECTIONREADONLYFIELD:
        return FormFields.SelectionReadonlyField;
      case FormEnums.FormFieldType.MULTIPLEAUTOCOMPLETE:
        return FormFields.MultipleAutoCompleteTextFormField;
      case FormEnums.FormFieldType.COMPACTEDITABLETABLE:
        return FormFields.CompactEditableTableFormField;
      case FormEnums.FormFieldType.SUBFORM:
        return FormFields.SubFormFormField;
      default:
        return undefined;
    }
  }, [props.field.type]);

  return FieldComponent !== undefined ? (
    <FieldComponent<T>
      fieldRef={props.fieldRef}
      name={props.name}
      field={props.field}
      hideErrorBubble={props.hideErrorBubble}
      hideSuccess={props.hideSuccess}
      messagePlacement={props.messagePlacement}
      invertedDisplayType={props.invertedDisplayType}
      inline={props.inline}
      enableControlLables={props.enableControlLables}
      contentWidth={props.contentWidth}
      formGridLayout={props.formGridLayout}
      layout={props.layout}
      validationSchema={props.validationSchema}
      overrideOptional={props.overrideOptional}
      hideOptionalIndicator={props.hideOptionalIndicator}
      focusField={props.focusField}
      value={props.value}
      touched={props.touched}
      errors={props.errors}
      success={props.success}
      optional={props.optional}
      disabled={props.disabled}
      readonly={props.readonly}
      loading={props.loading}
      handleOnChange={props.handleOnChange}
      handleOnChangeCustom={props.handleOnChangeCustom}
      handleOnBlurCustom={props.handleOnBlurCustom}
    />
  ) : null;
}

export default FormField;
